<mat-card appearance="outlined">
  <div class="body-2 text-muted align-center" *ngIf="!legals || !legals?.length">
    <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
    {{ 'general.api_users_form_legal_persons_empty' | translate }}
  </div>
  <table class="report-table manual-alternating-color bottom-spacer desktop" *ngIf="legals?.length">
    <thead>
      <tr>
        <th class="quarter-width">{{'general.api_users_form_legal_person' | translate}}</th>
        <th>{{'general.api_users_form_salespoint' | translate}}</th>
        <th>{{'general.api_users_form_role' | translate}}</th>
        <th *ngIf="!isMyProfile" class="min-width">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let legalPerson of legals; let even = even">
        <tr [ngClass]="{'alternate' : even}">
          <td [rowSpan]="legalPerson.salespoints.length || 1">
            <span class="title">{{ legalPerson.companyName || '-' }}</span>
          </td>
          <td>
            <span class="title">{{ legalPerson.salespoints[0]?.name || '-' }}</span>
            <ng-container *ngIf="legalPerson.salespoints[0]?.alias?.id">
              <br>
              <span class="text-grey">{{ legalPerson.salespoints[0].alias.name }}</span>
            </ng-container>
          </td>
          <td>
            <span>{{ ((legalPerson.salespoints[0]?.roleNames || []) | roles) || '-' }}</span>
            <ng-container *ngIf="legalPerson.salespoints[0]?.alias?.id">
              <br>
              <span class="text-grey">{{ ((legalPerson.salespoints[0].alias.roleNames || []) | roles) || '-' }}</span>
            </ng-container>
          </td>
          <td *ngIf="!isMyProfile" class="white-space-no-wrap align-right" [rowSpan]="legalPerson.salespoints.length || 1">
            <button mat-button class="left-spacer icon-button input-button small" *ngIf="!isView" (click)="edit.emit(legalPerson.legalPersonId)">
              <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
            </button>
            <button mat-button class="left-spacer icon-button input-button small" *ngIf="!isView && !isSameSalespoint(legalPerson)"
                    (click)="remove.emit(legalPerson.legalPersonId)">
              <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
            </button>
          </td>
        </tr>
        <ng-container *ngFor="let legalPersonSalespoint of legalPerson.salespoints; let first = first">
          <tr *ngIf="!first" [ngClass]="{'alternate' : even}">
            <td>
              <span class="title">{{ legalPersonSalespoint.name }}</span>
              <ng-container *ngIf="legalPersonSalespoint.alias?.id">
                <br>
                <span class="text-grey">{{ legalPersonSalespoint.alias.name }}</span>
              </ng-container>
            </td>
            <td>
              <span>{{ ((legalPersonSalespoint.roleNames || []) | roles) || '-' }}</span>
              <ng-container *ngIf="legalPersonSalespoint.alias?.id">
                <br>
                <span class="text-grey">{{ ((legalPersonSalespoint.alias.roleNames || []) | roles) || '-' }}</span>
              </ng-container>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>


  <div class="mobile">
    <div class="listing-block" *ngFor="let legalPerson of legals; let last = last" [ngClass]="{'last-block': last}">
      <div class="header-block flex flex-grow space-between bottom-spacer">
        <div>
          <a class="heading-5 no-margin break-word link bold" (click)="$event.stopPropagation(); !isMyProfile && edit.emit(legalPerson.legalPersonId)">{{ legalPerson.companyName || '-' }}</a>
          <span class="text-muted">{{'general.api_users_form_legal_person' | translate}}</span>
        </div>
        <div class="white-space-no-wrap no-grow no-min-width" *ngIf="!isView && !isMyProfile">
          <button mat-button class="left-spacer icon-button input-button small" (click)="edit.emit(legalPerson.legalPersonId)">
            <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
          </button>
          <button mat-button class="left-spacer icon-button input-button small" *ngIf="!isSameSalespoint(legalPerson)"
                  (click)="remove.emit(legalPerson.legalPersonId)">
            <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
          </button>
        </div>
      </div>
      <table class="mobile-max-width bottom-spacer">
        <tbody>
          <tr>
            <td>{{'general.api_users_form_salespoint' | translate}}</td>
            <td class="align-right">
              <b>{{ legalPerson.salespoints[0]?.name || '-' }}</b>
              <ng-container *ngIf="legalPerson.salespoints[0]?.alias?.id">
                <br>
                <span class="text-grey">{{ legalPerson.salespoints[0].alias.name }}</span>
              </ng-container>
            </td>
          </tr>
          <tr>
            <td>{{'general.api_users_form_role' | translate}}</td>
            <td class="align-right">
              <span>{{ ((legalPerson.salespoints[0]?.roleNames || []) | roles) || '-' }}</span>
              <ng-container *ngIf="legalPerson.salespoints[0]?.alias?.id">
                <br>
                <span class="text-grey">{{ ((legalPerson.salespoints[0].alias.roleNames || []) | roles) || '-' }}</span>
              </ng-container>
            </td>
          </tr>
          <ng-container *ngFor="let legalPersonSalespoint of legalPerson.salespoints; let first = first">
            <tr *ngIf="!first">
              <td>{{'general.api_users_form_salespoint' | translate}}</td>
              <td class="align-right">
                <b>{{ legalPersonSalespoint.name }}</b>
                <ng-container *ngIf="legalPersonSalespoint.alias?.id">
                  <br>
                  <span class="text-grey">{{ legalPersonSalespoint.alias.name }}</span>
                </ng-container>
              </td>
            </tr>
            <tr *ngIf="!first">
              <td>{{'general.api_users_form_role' | translate}}</td>
              <td class="align-right">
                <span>{{ ((legalPersonSalespoint.roleNames || []) | roles) || '-' }}</span>
                <ng-container *ngIf="legalPersonSalespoint.alias?.id">
                  <br>
                  <span class="text-grey">{{ ((legalPersonSalespoint.alias.roleNames || []) | roles) || '-' }}</span>
                </ng-container>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <hr class="no-margin">
    </div>
  </div>
</mat-card>
